import React from 'react';

import {SelectOption} from '@gravity-ui/uikit';

import {cnDropdownQuestion} from './DropdownQuestion.constants';

export const renderOption = ({content}: SelectOption) => {
    return (
        <span title={content as string} className={cnDropdownQuestion('Option')}>
            {content}
        </span>
    );
};
